import { objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from '../../_virtual/react-responsive.js';
import Container from '../../node_modules/reactstrap/esm/Container.js';
import map from '../../node_modules/ramda/es/map.js';
import { MobileMenuFrame, Container as Container$1, BarMenuTitle, MenuBtn, DropdownIcon, NavFrame, DropdownMenu, Link, ExternalLink, Action, ExternalAction } from './styled.js';

var toUpperCaseLabels = map(function (opt) {
  return _objectSpread2(_objectSpread2({}, opt), {}, {
    label: opt.label.toUpperCase()
  });
});
var generateActionsLink = function generateActionsLink(options, ExternalAction, Action, _Divider) {
  return options.map(function (_ref) {
    var to = _ref.to,
      label = _ref.label,
      classNames = _ref.classNames,
      external = _ref.external,
      isActive = _ref.isActive;
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: label
    }, external ? /*#__PURE__*/React__default.createElement(ExternalAction, {
      key: label,
      href: to,
      className: classNames
    }, label) : /*#__PURE__*/React__default.createElement(Action, {
      key: label,
      to: to,
      className: function className(_ref2) {
        var routerIsActive = _ref2.isActive;
        return "".concat(classNames || "", " ").concat(isActive || routerIsActive ? "active" : "");
      }
    }, label));
  });
};
var DropDown = function DropDown(_ref3) {
  var options = _ref3.options,
    isOpen = _ref3.isOpen,
    toggleDropdown = _ref3.toggleDropdown,
    _ref3$CompLink = _ref3.CompLink,
    CompLink = _ref3$CompLink === void 0 ? Action : _ref3$CompLink;
  return /*#__PURE__*/React__default.createElement(DropdownMenu, {
    onClick: function onClick() {
      return toggleDropdown(!isOpen);
    },
    isOpen: isOpen
  }, generateActionsLink(options, ExternalAction, CompLink));
};
var NavBar = function NavBar(_ref4) {
  var options = _ref4.options,
    _ref4$CompLink = _ref4.CompLink,
    CompLink = _ref4$CompLink === void 0 ? Link : _ref4$CompLink;
  return /*#__PURE__*/React__default.createElement(NavFrame, null, generateActionsLink(options, ExternalLink, CompLink));
};
var MobileNav = function MobileNav(_ref5) {
  var title = _ref5.title,
    menuTitle = _ref5.menuTitle,
    options = _ref5.options,
    CompLink = _ref5.CompLink;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    toggleDropdown = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(MobileMenuFrame, null, /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(BarMenuTitle, null, title), /*#__PURE__*/React__default.createElement(MenuBtn, {
    onClick: function onClick() {
      return toggleDropdown(!isOpen);
    },
    open: isOpen
  }, menuTitle, /*#__PURE__*/React__default.createElement(DropdownIcon, {
    open: isOpen
  })))), /*#__PURE__*/React__default.createElement(DropDown, {
    options: options,
    isOpen: isOpen,
    toggleDropdown: toggleDropdown,
    CompLink: CompLink
  }));
};
var SecondaryNav = function SecondaryNav(_ref6) {
  var title = _ref6.title,
    menuTitle = _ref6.menuTitle,
    options = _ref6.options,
    breakpoint = _ref6.breakpoint,
    CompLink = _ref6.CompLink;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(MediaQuery, {
    maxWidth: breakpoint - 1
  }, /*#__PURE__*/React__default.createElement(MobileNav, {
    title: title,
    menuTitle: menuTitle,
    options: options,
    CompLink: CompLink
  })), /*#__PURE__*/React__default.createElement(MediaQuery, {
    minWidth: breakpoint
  }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(NavBar, {
    options: toUpperCaseLabels(options),
    CompLink: CompLink
  }))));
};
SecondaryNav.defaultProps = {
  breakpoint: 998
};
SecondaryNav.propTypes = {
  breakpoint: PropTypes.number,
  title: PropTypes.string,
  menuTitle: PropTypes.string,
  CompLink: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    external: PropTypes.bool,
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    classNames: PropTypes.string
  }))
};

export { DropDown, MobileNav, NavBar, SecondaryNav as default };
